import React from 'react';

export interface ChatContextValue {
  openFile: (chatSessionId: string, externalFileId: string, filename: string, mimeType: string) => void;
}

export const ChatContext = React.createContext<ChatContextValue | null>(null);
